import { Text } from "grommet";

export interface LeadLabelProps {
  label: string;
  rowIndex: number;
  colIndex: number;
}
export function LeadLabel({ label, colIndex, rowIndex }: LeadLabelProps): React.ReactElement {
  const left_list = ["0%", "25%", "50%", "75%"];
  const left = left_list[colIndex];
  const top_list = ["0%", "33.33333%", "66.66666%"];
  const top = top_list[rowIndex];
  const index = rowIndex * 4 + colIndex;
  const background = (index % 2 === 1 && rowIndex % 2 === 0) || (index % 2 === 0 && rowIndex % 2 === 1) ? "#fff" : "#f4faff";

  return (
    <div style={{ position: "absolute", width: "25%", height: "33.3333%", left: `${left}`, top: `${top}`, background }}>
      <div style={{ position: "absolute", zIndex: 100, padding: "15px" }}>
        <Text style={{ lineHeight: 1 }} size="20px">
          {label}
        </Text>
      </div>
    </div>
  );
}
